import { useCallback, useEffect } from 'react';

import { useUser } from './use-user';
import { api } from '../../api';
import { isWixUser } from '../utils';

let updatedTz = false;

export const useSaveTimezone = () => {
  const [updateTz] = api.useUpdateTzMutation();

  const { isLoading, user } = useUser();

  const shouldSetTz = useCallback(() => {
    if (isLoading || !user || updatedTz) {
      return false;
    }

    if (isWixUser(user)) {
      return user.shouldSetTz;
    }

    return !user.timeZone;
  }, [isLoading, user]);

  useEffect(() => {
    if (shouldSetTz()) {
      updateTz({
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        timeZoneOffset: -new Date().getTimezoneOffset(),
      }).then(() => {
        updatedTz = true;
      });
    }
  }, [shouldSetTz, updateTz]);
};
